import styled from 'styled-components';

const DetailAddonAnimatableContainer = styled.div<{ ratio: number }>`
  animation: scroll 10s infinite linear 2s;  
  width: fit-content;
  white-space: nowrap;

  @keyframes scroll {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-${(props) => {
        const titlePercentage = (100 * props.ratio) / (2 * props.ratio + 1);
        const transformPercentage =
          titlePercentage + titlePercentage / props.ratio;
        return transformPercentage;
      }}%);
    }
`;

export default DetailAddonAnimatableContainer;
